import { useCallback } from 'react';
import { useCountry } from '../../components/CountrySelector';
import { UserRewardStatus } from '../../constants';
import { useSkippableQuery } from '../useSkippableQuery';
import { useUser } from '../useUser';
import { GET_REWARDS_SUMMARY_QUERY } from './rewardsSummary.rest';

const PAGE_SIZE = 20;

export const useRewardsSummary = (currency: string) => {
  const {
    country: { alpha2Code }
  } = useCountry();
  const {
    user: { userLoyaltyStatus }
  } = useUser();

  const { data, loading, error, fetchMore: fetchMoreFn } = useSkippableQuery(
    GET_REWARDS_SUMMARY_QUERY,
    {
      variables: {
        countryCode: alpha2Code,
        currency,
        pageNumber: 1,
        pageSize: PAGE_SIZE
      },
      skip: userLoyaltyStatus !== UserRewardStatus.Enrolled,
      notifyOnNetworkStatusChange: true
    }
  );

  const attributes = data?.getRewardsSummary.data[0]?.attributes;

  const currentPageNumber = attributes?.getRewardsSummary.currentPageNumber || 1;
  const totalRecords = attributes?.getRewardsSummary.totalRecords || 0;

  const fetchMore = useCallback(() => {
    fetchMoreFn({
      variables: {
        pageNumber: currentPageNumber + 1
      }
    });
  }, [currentPageNumber, fetchMoreFn]);

  return {
    rewardsData: attributes?.getRewardsData,
    rewardsSummary: attributes?.getRewardsSummary.summary,
    expiresOn: attributes?.expiresOn,
    loading,
    error,
    fetchMore: PAGE_SIZE * currentPageNumber <= totalRecords ? fetchMore : undefined,
    totalRecords
  };
};
